/**
 * Lazy-load below-the-fold videos.
 * Keep real src only on first-screen heroes; everything else uses data-src.
 */
(function () {
  const SELECTOR = "video[data-lazy-video]";

  function activateVideo(video) {
    if (video.dataset.lazyLoaded === "1") return;
    video.dataset.lazyLoaded = "1";

    const dataSrc = video.getAttribute("data-src");
    if (dataSrc) {
      video.src = dataSrc;
      video.removeAttribute("data-src");
    }

    video.querySelectorAll("source[data-src]").forEach((source) => {
      source.src = source.getAttribute("data-src");
      source.removeAttribute("data-src");
    });

    video.load();

    const shouldAutoplay =
      video.hasAttribute("data-autoplay") ||
      video.getAttribute("data-autoplay") === "true";

    if (shouldAutoplay) {
      const tryPlay = () => {
        video.play().catch(() => {});
      };
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener("loadeddata", tryPlay, { once: true });
      }
    }
  }

  function initLazyVideos() {
    const videos = document.querySelectorAll(SELECTOR);
    if (!videos.length) return;

    if (!("IntersectionObserver" in window)) {
      videos.forEach(activateVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          activateVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        // Start slightly before visible for UX; still below Lighthouse first viewport for deep sections
        rootMargin: "150px 0px",
        threshold: 0.01,
      }
    );

    videos.forEach((video) => observer.observe(video));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
